import type { HighlighterCore } from "shiki/core";

// Only the languages and themes listed here are bundled. Adding a new language
// means importing its grammar from "@shikijs/langs/<name>" below.
const LANG_ALIASES: Record<string, string> = {
  sh: "bash",
  shell: "bash",
  zsh: "bash",
  js: "javascript",
  ts: "typescript",
  py: "python",
  yml: "yaml",
  cs: "csharp",
};

const SUPPORTED_LANGS = new Set([
  "bash",
  "javascript",
  "typescript",
  "jsx",
  "tsx",
  "json",
  "yaml",
  "python",
  "sql",
  "markdown",
  "html",
  "css",
  "diff",
  "csharp",
  "go",
  "text",
]);

let highlighterPromise: Promise<HighlighterCore> | null = null;

export function getHighlighter(): Promise<HighlighterCore> {
  if (!highlighterPromise) {
    highlighterPromise = (async () => {
      const [{ createHighlighterCore }, { createOnigurumaEngine }] = await Promise.all([
        import("shiki/core"),
        import("shiki/engine/oniguruma"),
      ]);

      return createHighlighterCore({
        themes: [
          import("@shikijs/themes/github-light"),
          import("@shikijs/themes/github-dark"),
        ],
        langs: [
          import("@shikijs/langs/bash"),
          import("@shikijs/langs/javascript"),
          import("@shikijs/langs/typescript"),
          import("@shikijs/langs/jsx"),
          import("@shikijs/langs/tsx"),
          import("@shikijs/langs/json"),
          import("@shikijs/langs/yaml"),
          import("@shikijs/langs/python"),
          import("@shikijs/langs/sql"),
          import("@shikijs/langs/markdown"),
          import("@shikijs/langs/html"),
          import("@shikijs/langs/css"),
          import("@shikijs/langs/diff"),
          import("@shikijs/langs/csharp"),
          import("@shikijs/langs/go"),
        ],
        engine: createOnigurumaEngine(import("shiki/wasm")),
      });
    })();
  }
  return highlighterPromise;
}

export function normalizeLang(raw: string | undefined | null): string {
  if (!raw) return "text";
  const lower = raw.toLowerCase().trim();
  const aliased = LANG_ALIASES[lower] ?? lower;
  return SUPPORTED_LANGS.has(aliased) ? aliased : "text";
}

export function preferredTheme(): "github-light" | "github-dark" {
  if (typeof document === "undefined") return "github-light";
  const attr = document.documentElement.getAttribute("data-theme");
  if (attr === "dark") return "github-dark";
  return "github-light";
}
